module.exports = __webpack_public_path__ + "static/media/code.ebb8dad9.svg";